import React, { useEffect, useState } from "react";
import { grouplist, groupmemberlist, outstandinglist } from "../../../services/admin";
import exportUrl from "../../../exportUrl";
import { toast } from "react-toastify";
import moment from "moment";
import Select from "react-select";

export const OutstandingSheet = () => {
    const [glist, setGlist] = useState([]);
    const [grpid, setGrpId] = useState("");
    const [mgrpid, setMGrpId] = useState("");
    const [mlist, setMlist] = useState([]);
    const [memid, setMemId] = useState("");
    const [filterProduct, setFilterProduct] = useState([]);

    useEffect(() => {
        const temp = new FormData();
        temp.append("branch", localStorage.getItem("branch"));
        grouplist(temp).then((res) => {
            if (res.status === true) {
                let arr = [];
                if (res.data.length > 0) {
                    for (let i = 0; i < res.data.length; i++) {
                        arr.push({
                            value: res.data[i].id,
                            label: res.data[i].group_name
                        })
                    }
                    setGlist(arr);
                }
            }
        })
    }, []);

    function handlegroup(e) {
        if (e !== null) {
            setMGrpId(e);
            setGrpId(e.value);
            setMemId("");
            setMlist([]);
            setFilterProduct([]);
            if (e.value != "") {
                groupmemberlist(e.value).then((res) => {
                    if (res.status === true) {
                        setMlist(res.data);
                    }
                });
            }
        } else {
            setMGrpId("");
            setGrpId("");
            setMemId("");
            setMlist([]);
            setFilterProduct([]);
        }

    }

    function handlemember(e) {
        setMemId(e.target.value);
        setFilterProduct([]);
        if (e.target.value != "") {
            const temp = new FormData();
            temp.append("group_id", grpid);
            temp.append("member_id", e.target.value);
            outstandinglist(temp).then((res) => {
                if (res.status === true) {
                    setFilterProduct(res.data);
                }
            });
        }
    }
    function downloadfile(fid, mid, dtype) {
        if (fid !== "" && mid !== "") {
            window.open(exportUrl + 'report/outstandingdownload?group_id=' + fid + '&member_id=' + mid + '&type=' + dtype + '&branch=' + (localStorage.getItem("branch") || ""), "_blank");
        } else {
            toast.error("Please Select Group");
        }
    }
    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">Outstanding Report</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Report</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Outstanding Report
                    </li>
                </ol>
            </div>

            <div className="content-body">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-header">
                                <h2 className="main-content-title tx-24 mg-b-5">
                                    Outstanding Report
                                </h2>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-xl-4 col-sm-6">
                                        <div className="mb-6">
                                            <label className="form-label">
                                                Group<span className="text-danger"> *</span>
                                            </label>
                                            <Select
                                                className="default-select"
                                                placeholder="Select Select Group"
                                                value={mgrpid}
                                                options={glist}
                                                onChange={handlegroup}
                                                isSearchable={true}
                                                isClearable
                                                hidden
                                            />
                                            {/* <select
                                                className="default-select form-control wide"
                                                onChange={handlegroup}
                                                value={grpid}
                                            >
                                                <option value="" disabled>
                                                    Select Group
                                                </option>
                                                {glist.map((item, index) => {
                                                    return (
                                                        <option key={index} value={item.id}>
                                                            {item.group_name}
                                                        </option>
                                                    );
                                                })}
                                            </select> */}
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-sm-6">
                                        <div className="mb-6">
                                            <label className="form-label">
                                                Member<span className="text-danger"> *</span>
                                            </label>
                                            <select
                                                className="default-select form-control wide"
                                                onChange={handlemember}
                                                value={memid}
                                            >
                                                <option value="" disabled>
                                                    Select Member
                                                </option>
                                                {mlist.map((item, index) => {
                                                    return (
                                                        <option key={index} value={item.id}>
                                                            {item.member_name}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-sm-6 mt-4">
                                        <div className="text-end">
                                            <a className="btn btn-danger me-2" onClick={() => downloadfile(grpid, memid, 'pdf')}>Download PDF</a>
                                            <a className="btn btn-success" onClick={() => downloadfile(grpid, memid, 'excel')}>Download Excel</a>
                                        </div>
                                    </div>

                                </div>
                                {filterProduct.map((item, index) => {
                                    return (
                                        <div className="row mt-4" key={index}>
                                            <div className="col-xl-3 col-sm-6">
                                                <p>
                                                    Collection Day : {item.group_collection_day}
                                                </p>
                                            </div>
                                            <div className="col-xl-3 col-sm-6">
                                                <p>
                                                    Interest Per Due : {parseFloat(item.interest).toFixed(2)}
                                                </p>
                                            </div>
                                            <div className="col-xl-3 col-sm-6">
                                                <p>
                                                    Loan Date : {item.loan_date !== null ? moment(item.loan_date).format('DD-MM-YYYY') : ''}
                                                </p>
                                            </div>
                                            <div className="col-xl-3 col-sm-6">
                                                <p>
                                                    Staff : {item.staff_name}
                                                </p>
                                            </div>
                                            <div className="table-container">
                                                <table className="responsive-table">
                                                    <thead>
                                                        <tr>
                                                            <th>S.No</th>
                                                            <th>Total EMI</th>
                                                            <th>Principle</th>
                                                            <th>Interest</th>
                                                            <th>Outstanding</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {item.scheme_entries.map((data, i) => {
                                                            return (
                                                                <tr key={i}>
                                                                    <td>{i + 1}</td>
                                                                    <td>{data.total}</td>
                                                                    <td>{data.remaining_total_amount}</td>
                                                                    <td>{data.interest}</td>
                                                                    <td>{data.outstanding}</td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <hr />
                                        </div>
                                    )
                                })

                                }

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
